import type { ElementType } from 'react'

import { useContext } from 'react'

import { FormKeyContext } from './key.context'
import { FormTypeContext } from './type.context'

export function withFormContext<T extends object> (Component: ElementType) {
  return function WithFormContext (props: T): JSX.Element {
    let key = useContext(FormKeyContext) ?? 'unknown'
    let type = useContext(FormTypeContext) ?? 'unknown'

    return (
      <Component
        formKey={`${type}_${key}`}
        {...props}
      />
    )
  }
}
